import { BulkActionConfirmationModal } from "../BulkActionConfirmationModal";

type MarkAsStandaloneModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
  selectedEntityCount: number;
};

export const MarkAsStandaloneModal = (props: MarkAsStandaloneModalProps) => (
  <BulkActionConfirmationModal
    {...props}
    title="Mark as standalone"
    confirmationText={`The selected ${props.selectedEntityCount === 1 ? "entity" : "entities"} will be marked as standalone.`}
    testId="mark-as-standalone-modal"
  />
);
